import { getLineWidth } from '../PlanUsage.utils';
import { IndicatorContainer, NumberIndicator } from '../PlanUsage.styles';
import { Label } from '../../TypographyNew';
import { TPlanUsageInterval } from '../PlanUsage.type';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';

type LineProps = {
  active?: boolean;
  noHover?: boolean;
  width: string;
};

const IntervalContainer = styled.div<{
  width: string;
  active: boolean;
  noHover?: boolean;
}>`
  position: relative;
  height: inherit;
  width: ${(p) => p.width};
  z-index: 1;

  &:nth-child(3) {
    border-bottom-left-radius: var(--radius-100);
    border-top-left-radius: var(--radius-100);

    > div {
      width: calc(100% - var(--spacing-s));
      margin-left: var(--spacing-s);
    }
  }

  :last-of-type {
    border-bottom-right-radius: var(--radius-100);
    border-top-right-radius: var(--radius-100);

    > div {
      width: calc(100% - var(--spacing-s));
      margin-right: var(--spacing-s);
    }
  }

  ${(p) =>
    p.active
      ? css`
          #indicator-lines {
            border-color: var(--color-feedback-success-darkest);
          }
        `
      : css`
          * {
            display: none;
          }

          :hover {
            background: var(--color-brand-purple1-normal);

            * {
              display: block;
            }
          }
        `}

  ${(p) =>
    p.noHover &&
    css`
      pointer-events: none;
    `}
`;

const Interval: FC<LineProps> = ({
  active = false,
  width,
  noHover,
  children,
}) => {
  return (
    <IntervalContainer width={width} active={active} noHover={noHover}>
      {children}
    </IntervalContainer>
  );
};

type IntervalsProps = {
  intervals: TPlanUsageInterval[];
  value: number;
  noIndicator?: boolean;
};
export const Intervals: FC<IntervalsProps> = ({
  intervals,
  value,
  noIndicator,
}) => {
  const lastMinValue = intervals[intervals.length - 1].min;

  return (
    <>
      {intervals.map((interval) => (
        <Interval
          noHover={noIndicator}
          key={`interval_${interval.price}`}
          active={
            (value >= interval.min && value < interval.max) ||
            // if the value is above the last interval, make the last interval active
            (interval.min === lastMinValue && value > lastMinValue)
          }
          width={getLineWidth(interval.max, intervals)}
        >
          {!noIndicator && (
            <IndicatorContainer id={'indicator-lines'}>
              <NumberIndicator>
                <Label variant={2}>${interval.price}</Label>
              </NumberIndicator>
            </IndicatorContainer>
          )}
        </Interval>
      ))}
    </>
  );
};
